import axios from "axios";

// Replace key for youtube data(in case of 403 error)
// 1. AIzaSyD6o5vZyWczfvqsCproaNk5wDZCwHZjVbE - using
// 2. AIzaSyBheETR9dLgJaHh7IYB5FawM5jnAPFk1k4
// 3. AIzaSyBXNUxUhWKSh7IaX59zRAE4xLmCE64QMb8
// 4. AIzaSyD7la5MalA1LWecEIYv1WWYJg_8Dr6nbmo
// 5. AIzaSyC2TYQEecJ4B6Zo38jzYU6_KdrkTaKiThI

// used
// AIzaSyBy9ih7DTpBAlxEwLzWew9_kbnHcoOossQ

const KEY = "AIzaSyBheETR9dLgJaHh7IYB5FawM5jnAPFk1k4";

export default axios.create({
  baseURL: "https://www.googleapis.com/youtube/v3",
  // validateStatus: function (status) {
  //   return alert(status ); // Resolve only if the status code is less than 500
  // },
  params: {
    part: "snippet",
    maxResults: 7,
    key: KEY
  },
  headers: {}
});